export default __webpack_public_path__ + "assets/images/transactmenu.svg";